export default {
  data () {
    return {
      validationRules: {
        requiredField: (field) => (v) => (v && v.length > 0) || `${field} is required`,
        validEmail: (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(v) || 'E-mail must be valid',
        requiredlength: (field, length) => v => (!v || v.length === length) || `${field} must be ${length} characters long`,
        validPhone: (v) => /.+@.+\..+/.test(v) || 'Phone number must be valid',
        minLength: l => v => (v && v.length >= l) || `min. ${l} Characters`,
        maxLength: l => v => (v && v.length <= l) || `max. ${l} Characters`
      }
    }
  }
}
